/* ==========================================================================
   CHALURE — akcijos laikas (2026-09 akcija)

   Vienas laikrodis visai temai:
     • [data-promo-countdown]   — tekstas „4 d. 11:22:33" iki promo_end_at
     • [data-promo-el]          — akcijos elementas: slepiamas iki pradžios ir po pabaigos
     • [data-promo-msg]         — announcement žinutė su data-from / data-until
     • [data-promo-after]       — rodomas tik nuo nurodyto laiko (pvz. „Liko N vnt.")

   Konfigūracija ateina iš layout/theme.liquid → window.ChalurePromoConfig
   { start, end, active }.

   PREVIEW: nepublikuotoje temoje (Shopify.theme.role !== 'main') laikas
   „pastumiamas" į akcijos pradžią, kad elementai matytųsi prieš 09-28.
   Kitą datą galima pasitikrinti: ?promo_now=2026-10-13T10:00:00+03:00
   (išvalyti: ?promo_now=clear). Gyvoje temoje override neveikia.
   ========================================================================== */
(function () {
  'use strict';
  if (window.ChalurePromo) return;

  var cfg = window.ChalurePromoConfig || {};
  var role = (window.Shopify && Shopify.theme && Shopify.theme.role) || 'main';

  function parse(s) {
    if (!s) return null;
    var t = Date.parse(s);
    return isNaN(t) ? null : t;
  }

  var START = parse(cfg.start);
  var END = parse(cfg.end);
  var offset = 0;

  if (role !== 'main') {
    var override = null;
    try {
      var q = new URLSearchParams(location.search).get('promo_now');
      if (q === 'clear') sessionStorage.removeItem('chalurePromoNow');
      else if (q) sessionStorage.setItem('chalurePromoNow', q);
      override = sessionStorage.getItem('chalurePromoNow');
    } catch (e) {}
    var o = parse(override);
    if (o) offset = o - Date.now();
    else if (START && Date.now() < START) offset = START - Date.now() + 1000;
  }

  function now() { return Date.now() + offset; }

  function state() {
    var t = now();
    if (!cfg.active) return 'off';
    if (START && t < START) return 'pending';
    if (END && t >= END) return 'ended';
    return 'live';
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function format(ms) {
    if (ms <= 0) return '00:00:00';
    var s = Math.floor(ms / 1000);
    var d = Math.floor(s / 86400); s -= d * 86400;
    var h = Math.floor(s / 3600); s -= h * 3600;
    var m = Math.floor(s / 60); s -= m * 60;
    var hms = pad(h) + ':' + pad(m) + ':' + pad(s);
    return d > 0 ? d + ' d. ' + hms : hms;
  }

  function applyState() {
    var st = state();
    var root = document.documentElement;
    root.classList.toggle('promo-live', st === 'live');
    root.classList.toggle('promo-off', st !== 'live');
    return st;
  }

  function inWindow(el, t) {
    var from = parse(el.getAttribute('data-from'));
    var until = parse(el.getAttribute('data-until'));
    if (from && t < from) return false;
    if (until && t > until) return false;
    return true;
  }

  function tick() {
    var st = applyState();
    var left = END ? END - now() : 0;
    var txt = format(left);
    var nodes = document.querySelectorAll('[data-promo-countdown]');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].textContent !== txt) nodes[i].textContent = txt;
    }
    var t = now();
    var after = document.querySelectorAll('[data-promo-after]');
    for (var j = 0; j < after.length; j++) {
      var from = parse(after[j].getAttribute('data-promo-after'));
      after[j].hidden = !(st === 'live' && (!from || t >= from));
    }
    return st;
  }

  /* ---- Announcement: rodom tik žinutes, kurių laikas tinka ---- */
  function setupRotators() {
    var rotators = document.querySelectorAll('[data-announcement-rotator]');
    Array.prototype.forEach.call(rotators, function (rotator) {
      if (rotator.__promoInit) return;
      rotator.__promoInit = true;
      var speed = parseInt(rotator.getAttribute('data-speed'), 10) || 4000;
      var current = -1;

      function visible() {
        var t = now();
        var st = state();
        return Array.prototype.filter.call(rotator.querySelectorAll('[data-promo-msg]'), function (el) {
          if (el.hasAttribute('data-needs-promo') && st !== 'live') return false;
          return inWindow(el, t);
        });
      }

      function show() {
        var list = visible();
        var all = rotator.querySelectorAll('[data-promo-msg]');
        var fallback = rotator.querySelector('[data-promo-fallback]');
        for (var i = 0; i < all.length; i++) all[i].classList.remove('is-active');
        if (!list.length) {
          if (fallback) fallback.classList.add('is-active');
          return;
        }
        if (fallback) fallback.classList.remove('is-active');
        current = (current + 1) % list.length;
        list[current].classList.add('is-active');
      }

      show();
      setInterval(show, speed);
    });
  }

  window.ChalurePromo = { now: now, state: state, format: format, end: END, start: START };

  function boot() {
    tick();
    setupRotators();
    setInterval(tick, 1000);
  }

  applyState();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* krepšelio perpiešimas atneša naujus [data-promo-countdown] — atnaujinam iškart */
  document.documentElement.addEventListener('cart:refresh', function () { setTimeout(tick, 400); });
})();
